/**
 * Returns true if the two dates are the same (ignoring time), false otherwise.
 * @param dateA Date string or Date object
 * @param dateB Date string or Date object
 * @returns boolean
 */
export function isSameDate(dateA: string | Date, dateB: string | Date): boolean {
    const dA = new Date(dateA);
    const dB = new Date(dateB);
    return dA.getFullYear() === dB.getFullYear() &&
        dA.getMonth() === dB.getMonth() &&
        dA.getDate() === dB.getDate();
}